// extracted by mini-css-extract-plugin
export var button = "_nh-2";
export var card = "_nh-0";
export var closeButtonContainer = "_nh-3";
export var iconContainer = "_nh-1";